import { CENTRAL_POINTS_ENDPOINTS } from "./central_points/index"
import { DOCUMENT_APPROVAL_ENDPOINTS } from "./document-approval"
import { PINCODES_ENDPOINTS } from "./pincodes"
import { USERS_ENDPOINTS } from "./users/index"

export const CP_DETECT_ENDPOINTS = {
  document_approval: DOCUMENT_APPROVAL_ENDPOINTS,
  central_points: CENTRAL_POINTS_ENDPOINTS,
  users: USERS_ENDPOINTS,
  pincodes: PINCODES_ENDPOINTS,
}